const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8081/api';

function getToken(): string {
  return localStorage.getItem('token') || '';
}

export interface ImportCodeResponse {
  code: string;
  expiresAt: string; // RFC3339
}

export class ImportCodeError extends Error {
  code?: string;
  httpStatus?: number;
  constructor(message: string, code?: string, httpStatus?: number) {
    super(message);
    this.name = 'ImportCodeError';
    this.code = code;
    this.httpStatus = httpStatus;
  }
}

export async function generateImportCode(projectId: string): Promise<ImportCodeResponse> {
  const token = getToken();
  const res = await fetch(`${API_BASE}/projects/import-code/generate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ projectId }),
  });
  if (res.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
    throw new ImportCodeError('未登录', undefined, 401);
  }
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) {
    const code: string | undefined = typeof payload?.code === 'string' ? payload.code : undefined;
    const msg: string =
      (typeof payload?.error === 'string' && payload.error) ||
      (typeof payload?.message === 'string' && payload.message) ||
      'Request failed';
    throw new ImportCodeError(msg, code, res.status);
  }
  if (typeof payload?.code !== 'string' || typeof payload?.expiresAt !== 'string') {
    throw new ImportCodeError('返回数据格式错误', undefined, res.status);
  }
  return {
    code: payload.code,
    expiresAt: payload.expiresAt,
  };
}

export interface ImportCodeStatus {
  code: string;
  expiresAt: string;
  used: boolean;
}

export async function getImportCodeStatus(code: string): Promise<ImportCodeStatus> {
  const token = getToken();
  const res = await fetch(`${API_BASE}/projects/import-code/${encodeURIComponent(code)}/status`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    throw new ImportCodeError('查询导入码状态失败', undefined, res.status);
  }
  return res.json();
}
